<template>
  <div class='usermodal'>
    <Button @click="userBtn(msg,usertem)">
      <Icon :type="icon" />{{msg}}
    </Button>
    <Modal
      v-model="modal1"
      footer-hide
      class="userModal"
    >
      <p slot="header">
        <span>{{msg}}用户</span>
      </p>

      <el-form
        :model="userForm"
        :rules="rules"
        ref="userForm"
        label-width="100px"
        class="userform"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="用户信息"
            name="first"
            class="userinfo"
          >

            <el-form-item
              label="账号"
              prop="account"
            >
              <el-input
                :disabled="msg == '编辑' ? true:false"
                v-model="userForm.account"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="学/工号"
              prop="usercode"
            >
              <el-input v-model="userForm.usercode"></el-input>
            </el-form-item>
            <el-form-item
              label="姓名"
              prop="username"
            >
              <el-input v-model="userForm.username"></el-input>
            </el-form-item>
            <el-form-item
              label="角色"
              prop="roleid"
            >
              <el-select
                v-model="userForm.roleid"
                placeholder="请选择角色"
                style="width:100%"
              >
                <el-option
                  v-for="(item,index) in roleList"
                  :key="item.roleid"
                  :label="item.rolename"
                  :value="item.roleid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="学科"
              prop="subjectid"
            >
              <el-select
                v-model="userForm.subjectid"
                placeholder="请选择学科"
                style="width:100%"
                multiple
              >
                <el-option
                  v-for="(item,index) in subjectList"
                  :key="item.itemid"
                  :label="item.itemname"
                  :value="item.itemid"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别">
              <el-select
                v-model="userForm.gender"
                placeholder="请选择性别"
                style="width:100%"
              >
                <el-option
                  label="男"
                  :value=1
                ></el-option>
                <el-option
                  label="女"
                  :value=0
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="userForm.email"></el-input>
            </el-form-item>
            <el-form-item label="手机">
              <el-input v-model="userForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="微信">
              <el-input v-model="userForm.wechat"></el-input>
            </el-form-item>
            <el-form-item label="QQ">
              <el-input v-model="userForm.qq"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="userForm.description"
              ></el-input>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane
            label="管理班级"
            name="second"
          >
            <el-tree
              :data="specClassIds"
              :props="specClassprops"
              :default-checked-keys="checklist"
              ref="specClassRef"
              node-key="orgid"
              show-checkbox
              accordion
              @check-change="handleCheckChange"
            >
            </el-tree>
          </el-tab-pane>
        </el-tabs>

        <el-form-item style="margin-left:400px">
          <el-button
            type="primary"
            @click="submitForm('userForm')"
          >提交</el-button>
        </el-form-item>
      </el-form>

    </Modal>
  </div>
</template>
<script>
import Api from '../../api/index'
export default {
  data () {
    return {
      activeName: 'first',
      modal1: false,
      subjectList: [],
      roleList: [],
      userForm: {
        account: '',
        roleid: '',
        username: '',
        usercode: '',
        gender: null,
        email: '',
        phone: '',
        qq: '',
        wechat: '',
        description: '',
        subjectid: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        username: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        roleid: [
          { required: true, message: '请选择角色', trigger: 'change' },
        ],
        subjectid: [
          { required: true, message: '请选择学科', trigger: 'change' },
        ],
        usercode: [
          { required: true, message: '请输入学/工号', trigger: 'blur' },
        ],

      },
      specialtynList: [],//专业列表
      ClassList: [],//班级列表
      specClassIds: [],
      checklist: [],
      specClassprops: {
        label: 'orgname',
        children: 'children'
      },
    }
  },
  props: {
    msg: String,
    icon: String,
    usertem: Object,
  },
  created () {
    this.GetDataItemListByCode()
  },
  methods: {
    //获取学科
    async GetDataItemListByCode () {
      const params = {
        itemcode: 'ExperimentType'
      }
      const res = await Api.dictionary.GetDataItemListByCode(params)
      if (res.success != true) return this.$message.info(res.msg)
      this.subjectList = res.rows
    },
    //用户管理按钮
    async userBtn (msg) {
      const res = await Api.role.GetDataList()
      if (res.success != true) return this.$Message.info(res.msg)
      this.roleList = res.rows
      if (msg == '编辑' && JSON.stringify(this.usertem) == '{}') {
        return this.$Message.info('请选择需要编辑的用户！')
      } else if (msg == '编辑') {
        this.userForm = this.usertem
        if (!Array.isArray(this.userForm.subjectid) && this.userForm.subjectid) this.userForm.subjectid = this.userForm.subjectid.split(',')
        const res = await Api.userinfo.GetUserSpecClassData(this.userForm.userid)
        if (res.success != true) return this.$Message.info(res.msg)
        this.checklist = res.rows.checklist;
        this.specClassIds = res.rows.orglist;
      }
      if (msg == '新增') {
        const res = await Api.userinfo.GetUserSpecClassData()
        if (res.success != true) return this.$Message.info(res.msg)
        this.specClassIds = res.rows.orglist;
      }
      this.modal1 = true;
    },

    //专业班级树形图选择
    handleCheckChange (data, checked, indeterminate) {
      if (checked) {
        data.ischeck = checked
      }
    },

    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let specClassIds = [...this.$refs.specClassRef.getCheckedKeys()]
          this.userForm.specClassIds = specClassIds
          this.userForm.gender = parseInt(this.userForm.gender)
          this.userForm.subjectid = this.userForm.subjectid.toString()
          const res = await Api.userinfo.SaveUser(this.userForm)
          if (res.success != true) return this.$Message.info(res.msg)
          this.$Message.success(res.msg)
          this.$emit('GetUserList')
          this.$refs[formName].resetFields();
          if (res.success) this.modal1 = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

  }
}
</script>
<style lang='less' scoped>
/deep/.ivu-modal,
.ivu-modal-body,
.ivu-modal-content {
  width: 800px !important;
}
/deep/.ivu-modal-content {
  width: 800px;
}
/deep/.userform {
  width: 750px;
  overflow: hidden;
}
/deep/.userinfo > div {
  float: left;
  width: 50%;
}
</style>